/**
 * Filters – Slider conversion utilities (pure math)
 */

import type { Units } from '../../utils';
import { HEIGHT_RANGE, HEIGHT_MIN_INCHES, HEIGHT_MAX_INCHES, RECENTLY_ACTIVE_SLIDER } from './types';

export function getHeightSliderMax(units: Units): number {
  if (units === 'imperial') return (HEIGHT_MAX_INCHES - HEIGHT_MIN_INCHES) + 2; // 32
  return (HEIGHT_RANGE.MAX_CM - HEIGHT_RANGE.MIN_CM) + 2; // 78
}

export function heightSliderToCm(pos: number, units: Units, isMax: boolean): number | null {
  const noMaxPos = getHeightSliderMax(units);
  if (pos <= 0) return null;
  if (pos >= noMaxPos) return null;
  if (units === 'imperial') {
    const inches = HEIGHT_MIN_INCHES + (pos - 1);
    return Math.round(inches * 2.54);
  }
  return HEIGHT_RANGE.MIN_CM + (pos - 1);
}

export function cmToHeightSlider(cm: number | null, units: Units, isMax: boolean): number {
  if (cm === null) return isMax ? getHeightSliderMax(units) : 0;
  if (units === 'imperial') {
    const inches = Math.round(cm / 2.54);
    return Math.max(1, Math.min(inches - HEIGHT_MIN_INCHES + 1, getHeightSliderMax(units) - 1));
  }
  return Math.max(1, Math.min(cm - HEIGHT_RANGE.MIN_CM + 1, getHeightSliderMax(units) - 1));
}

export function hoursToActivitySlider(hours: number | null): number {
  if (hours === null) return RECENTLY_ACTIVE_SLIDER.MAX;
  const idx = RECENTLY_ACTIVE_SLIDER.POSITIONS.findIndex(h => h === hours);
  return idx >= 0 ? idx : RECENTLY_ACTIVE_SLIDER.MAX;
}

export function activitySliderToHours(pos: number): number | null {
  return RECENTLY_ACTIVE_SLIDER.POSITIONS[pos] ?? null;
}

export function formatActivityLabel(hours: number | null): string {
  if (hours === null) return 'Any';
  const idx = RECENTLY_ACTIVE_SLIDER.POSITIONS.findIndex(h => h === hours);
  return idx >= 0 ? RECENTLY_ACTIVE_SLIDER.LABELS[idx] : 'Any';
}
